import { onCLS, onFCP, onINP, onLCP, onTTFB, type Metric } from "web-vitals";
import { getTracer } from "./otel";
import { analytics } from "./posthog-adapter";

/**
 * Core Web Vitals (ADR-0035), reported through BOTH pipes so the same signal is queryable
 * from traces (collector -> PostHog) and from PostHog events directly:
 *  - a zero-ish-duration span `web_vital.<name>` with the value/rating as attributes;
 *  - a `$web_vital` PostHog event via the AnalyticsClient port.
 *
 * web-vitals no-ops internally in browsers/environments without the needed
 * PerformanceObserver support (e.g. jsdom), so this is always safe to call.
 */
const report = (metric: Metric): void => {
  const span = getTracer("web-vitals").startSpan(`web_vital.${metric.name}`, {
    attributes: {
      "web_vital.name": metric.name,
      "web_vital.value": metric.value,
      "web_vital.rating": metric.rating,
    },
  });
  span.end();
  analytics.capture("$web_vital", {
    web_vital_name: metric.name,
    web_vital_value: metric.value,
    web_vital_rating: metric.rating,
    [`$web_vitals_${metric.name}_value`]: metric.value,
  });
};

export function initWebVitals(): void {
  onCLS(report);
  onFCP(report);
  onINP(report);
  onLCP(report);
  onTTFB(report);
}
